import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FiltersQueryTransformer } from "src/app/services/filters/filtersQueryTransformer.ts/filtersQueryTransformer";
import { BaseTopDataChartComponent } from "../base-top-data-chart/base-top-data-chart.component";

@Component({
    selector: "app-top-builders-data-chart",
    templateUrl: "./top-builders-data-chart.component.html",
    styleUrls: ["./top-builders-data-chart.component.scss"],
})
export class TopBuildersDataChartComponent extends BaseTopDataChartComponent {
    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
    ) {
        super();
    }

    public goToInventoryPageByCreatorId(builderId: string, resourceCategories: string): void {
        const filtersQuery = FiltersQueryTransformer.transformToQuery(this.filterOptions) + ` createdBy:${builderId} category:${resourceCategories}`;

        this._router.navigate(["inventory"], {
            relativeTo: this._activatedRoute.parent,
            queryParams: { q: filtersQuery },
            queryParamsHandling: "merge",
        });
    }

    public goToInventoryPageByCreatorIdAndResourceCategory(builderId: string, resourceCategory: string): void {
        const filtersQuery = FiltersQueryTransformer.transformToQuery(this.filterOptions) + ` createdBy:${builderId} category:${resourceCategory}`;

        this._router.navigate(["inventory"], {
            relativeTo: this._activatedRoute.parent,
            queryParams: { q: filtersQuery },
            queryParamsHandling: "merge",
        });
    }
}
